import React, {createContext} from "react";
import {Outlet} from "react-router";
import * as endpoints from "@localization/siteMap/endpoints/_SegurancaEndpoints.ts";
import {_SegurancaEndpoints} from "@localization/siteMap/endpoints/_SegurancaEndpoints.ts";


const defaults = {
    getContas: _SegurancaEndpoints.GetContas,
    getRoles: endpoints.getRoles,
    createRole: endpoints.createRole,
    enableConta: endpoints.enableConta,
    disableConta: endpoints.disableConta,
    addMembroRole: endpoints.addMembroRole,
    removeMembroRole: endpoints.removeMembroRole,
    getRolesMembro: endpoints.getRolesMembro,
    disableRole: endpoints.disableRole,
    enableRole: endpoints.enableRole
}

type SegurancaContextType = typeof defaults


export const SegurancaContext = createContext<SegurancaContextType>(defaults)

export const SegurancaProvider: React.FC = () => {

    return (
        <SegurancaContext.Provider value={defaults}>
            <Outlet/>
        </SegurancaContext.Provider>
    )
}

export const useSeguranca = () => {
    return React.useContext(SegurancaContext)
}